import { object, string, number } from 'yup'
import { ISearchZone } from '../../../interfaces/Zone/Zone'

export const definicionColumna: any[] = [
  {
    field: 'codigoZona',
    headerName: 'Cod Zona',
    flex: 1,
    headerAlign: 'center',
    align: 'center'
  },
  {
    field: 'nombreZona',
    headerName: 'Nombre',
    flex: 1,
    headerAlign: 'center',
    align: 'center'
  },
  {
    field: 'descripcionZona',
    headerName: 'Descripción',
    flex: 1,
    headerAlign: 'center',
    align: 'center'
  },
  {
    field: 'activo',
    headerName: 'Activo',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    valueGetter: (params: any) => (params.row.activo ? 'Si' : 'No')
  },
  {
    field: 'almacen',
    headerName: 'Almacén',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    valueGetter: (params: any) => params.row.almacen.nombreAlmacen
  }
  // Si es necesario agregar imagen
  // {
  //   field: 'image',
  //   headerName: 'Image',
  //   flex: 1,
  //   renderCell: () => <ImageProducto />
  // }
]

export const busquedaInitialState: ISearchZone = {
  zoneCode: '',
  zoneName: ''
}

export const createInitialValue = {
  id: 0,
  active: false
}

export const zonaValidationSchema = object({
  zoneName: string()
    .required('Debe ingresar un nombre para la zona')
    .min(1, 'Debe ingresar al menos 1 caracter')
    .max(50, 'Debe ingresar como máximo 50 caracteres')
    .matches(
      /^[^(a-z )]+[^(a-z)]*?[^\s]$/,
      'Nombre de Zona requiere mayúsculas, sin espacios al principio y al final'
    ),
  zoneDescription: string()
    .trim()
    .required('El campo descripción zona es requerido.')
    .min(1, 'Debe ingresar al menos 1 caracter')
    .max(200, 'Máximo 200 caracteres.'),
  warehouseId: number()
    .required('Debe seleccionar un almacén')
    .min(1, 'Debe seleccionar un almacén')
})
